import React,{useState,useEffect} from 'react';
import { createUseStyles } from 'react-jss';
import { Table,Button,Row,Col,Form } from 'react-bootstrap';
import { RightSidebar, RightSidebarInter } from '../RightSidebar/RightSidebar';
import moment from "moment";
import "moment/locale/es";
moment.locale("mx");

const styles = createUseStyles( theme => (
  {
    backgroundPrimary:{
      backgroundColor: theme.colorPrimary,
      '& .ws-directory-sidebar-list-badge p':{
        background: '#fff !important',
        color: theme.colorPrimary
      }
    },
    box: {
      backgroundColor: '#ffffff',
    },
    push: {
      cursor: 'pointer',
    },
    newClient: {
      cursor: 'pointer',
      fontStyle: 'italic',
      fontSize: '.8rem',
      fontWeight: '800',
      padding:'10px 5px',
      backgroundColor:'#ededed',
      margin:'10px 0px',
      borderRadius:'4px',
      textAlign: 'center',
      fontFamily: 'Open sans',
    },
    NombreCliente:{
      color: theme.colorPrimary
    },
    ListBadge:{
      background: `${theme.colorPrimary} !important`
    },
    ListItemActive:{
      backgroundColor: theme.colorPrimary,
      border: `2px solid ${theme.colorPrimary}`,
      cursor: 'pointer',
      '& p':{
        color:'#fff !important'
      },
      '& .ws-directory-sidebar-list-badge p': {
        background:'#fff !important',
        color: `${theme.colorPrimary} !important`
      },
      '&:hover':{
        backgroundColor: theme.colorPrimary,
        border: `2px solid ${theme.colorPrimary}`,
      }
    },
    inputLarge: {
      width: '100%',
      border: '2px solid #ccc',
      backgroundColor: '#f3f3f3',
    },
  
    p: {
      margin: 0,
    },
  
    LinkTab:{
      lineHeight:'35px',
      fontWeight:'700',
      fontSize:'1.1rem'
    },
  
    LinkTabActive:{
      color: theme.colorPrimary
    },
    ColorIcon:{
      color: `${theme.colorPrimary} !important`
    },
    SpinnerColor:{
      borderLeftColor: theme.colorPrimary
    },
    ProfileImage:{
      border: `4px solid ${theme.colorPrimary}` 
    },
    ProfileName:{
      color: theme.colorPrimary
    },
    ProfileDeleteIcon:{
      color: theme.colorPrimary
    },
    ProfileSeparator:{
      borderBottom: `2px solid ${theme.colorPrimary}`
    },
    ProfileSeparatorIcon:{
      background: `${theme.colorPrimary} !important`
    },
    BtnPrimary:{
      background: `${theme.colorPrimary} !important`,
      borderColor: `${theme.colorPrimary} !important`,
      '&:hover':{
        background: `${theme.colorPrimary} !important`,
        borderColor: `${theme.colorPrimary} !important`
      }
    },
    TabsPolizasBoxLeft:{
      border: '1px solid #d1d1d1',
      cursor: 'pointer',
      paddingTop: '6px',
      paddingBottom: '6px',
      borderTopLeftRadius: '3px',
      borderBottomLeftRadius: '3px',
      '& b':{
        fontWeight: '700',
        fontSize: '1.1rem',
      },
      '&:hover':{
        backgroundColor:'#ededed'
      },
      '&.active':{
        backgroundColor:'#ededed'
      }
    },
    TabsPolizasBoxRight:{
      border: '1px solid #d1d1d1',
      cursor: 'pointer',
      paddingTop: '6px',
      paddingBottom: '6px',
      borderTopRightRadius: '3px',
      borderBottomRightRadius: '3px',
      borderLeft:'none',
      '& b':{
        fontWeight: '700',
        fontSize: '1.1rem',
      },
      '&:hover':{
        backgroundColor:'#ededed'
      },
      '&.active':{
        backgroundColor:'#ededed'
      }
    },
    TabsPolizasText:{
      color: '#444',
      '&.active':{
        color: `${theme.colorPrimary} !important`
      }
    },
    DataColumn:{
      // borderLeft: '1px solid #ededed'
    },
    RamosList:{

    },
    RamosListNombre:{
      whiteSpace: 'wrap',
      '&.hide':{
        paddingLeft:'0px'
      }
    },
    ExpandIcon:{
      position: 'absolute',
      width: '0',
      height: '0',
      borderTop: '15px solid transparent',
      borderBottom: '15px solid transparent',
      borderRight: `15px solid ${theme.colorPrimary}`,
      marginTop: '3px',
      marginLeft: '-26px',
      cursor: 'pointer',
    },
    CloseButton:{
      borderBottom: '1px solid #ededed',
      lineHeight: '55px',
      transition: 'background 0.5s ease',
      '&:hover':{
        backgroundColor:'#ededed'
      }
    },
    TitleViewDetail:{
      fontWeight: '800',
      fontSize:'1.5rem',
    },
    TitleTableDetail:{
      fontWeight: '700',
      // borderBottom:'1px solid #f3f3f3',
    },
    PriceTableDetail:{
      fontFamily: 'Open sans',
      fontSize:'1.2rem'
    },
    TextTableDetail:{
      fontFamily: 'Open sans',
      fontSize:'1rem'
    },
    MonedaTableDetail:{
      fontFamily: 'Open sans',
      fontSize:'1rem'
    },
    LabelTagSuccess:{
      fontFamily: 'Open sans',
      fontSize: '.9rem',
      letterSpacing: '-1px',
      overflowWrap: 'break-word',
      fontWeight: '400',
      background: 'green',
      textAlign: 'center',
      color:' #fff',
      borderRadius: '4px',
      padding: '2px',
      width: '84%',
      margin: '0 auto',
    },
    LabelTagDanger:{
      fontFamily: 'Open sans',
      fontSize: '.9rem',
      letterSpacing: '-1px',
      overflowWrap: 'break-word',
      fontWeight: '400',
      background: '#df3444',
      textAlign: 'center',
      color:' #fff',
      borderRadius: '4px',
      padding: '2px',
      width: '84%',
      margin: '0 auto',
    },
    LabelTagWarning:{
      fontFamily: 'Open sans',
      fontSize: '.9rem',
      letterSpacing: '-1px',
      overflowWrap: 'break-word',
      fontWeight: '400',
      background: '#f9c31f',
      textAlign: 'center',
      color:' #fff',
      borderRadius: '4px',
      padding: '2px',
      width: '84%',
      margin: '0 auto',
    },
    MenuIconList:{
      fontSize: '2rem',
      color: '#777',
      cursor: 'pointer',
      opacity: '1',
  },
  MenuIconSubList:{
      lineHeight: 'normal !important',
      position: 'relative',
      top: '7px',
      left: '-4px',
      fontSize: '1.5rem',
  },
  SubMenuList:{
      textAlign: 'left',
      borderRadius: '3px',
      backgroundColor: '#fff',
      boxShadow: '0 1px 7px 0 rgb(0 0 0 / 10%)',
      position: 'absolute',
      // left: '0',
      zIndex: '9',
      opacity: '0',
      visibility: 'hidden',
      width: '200px',
      transition:' all 0.25s ease-out',
      left: '-150px !important',
      padding:'0px',
      '& li':{
          listStyle:'none'
      }
  },
  SubMenuListItem:{
    padding:'6px 10px',
    '&:hover':{
      backgroundColor: theme.colorPrimary,
      color: '#fff',
      cursor:'pointer'
    }
  },
  OptionList:{
      '&:hover > ul':{
          opacity:'1',
          visibility:'visible'
      }
  },

  
  }
))

export const Actividades = () => {

  const classes = styles();

  const [state,setState] = useState({
    search_input: '',
    isLoading: true,
    opt: '0',
    stepNuevaPoliza : 1,
    dataContrato : {
      companias : [],
      agentes : [],
    }
  })

  const [loadRegistro,setLoadRegistro] = useState(false);

  const [registro,setRegistro] = useState({
    id_cotizacion : '',
    identificador_cotizador: '',
    clave_agente: '',
    no_negocio: '',
    id_ramo: '',
    id_usuario: '',
    numero_poliza : '',
    fecha_inicio : '',
    fecha_fin : '',
    prima_total : '',
    prima_neta : '',
    forma_pago : '0',
    concepto : '0',
    company : '0',
    recibos: [],
    observacion: '',
  })

  const [showSidebarRight,setShowSidebarRight] = useState(false);

  const [sectionActividad,setSectionActividad] = useState({
    index: -1,
    arrPrioritarios: [],
    arrOtros: [],
    results: true,
  });

  useEffect(()=>{
    setLoadActividades()
  },[])

  function setOcultaPrioritario(index) {
    const data = { ...arrPrioritarios[index] }
    fetch(`REST/controllers/mainController?opt=setOcultaPrioritario`,{
      method: 'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      setLoadActividades()
    })

  }

  function setLoadActividades() {
    setState({
      ...state,
      isLoading: true
    })
    const data = {  }
    fetch(`REST/controllers/mainController?opt=getActivity`,{
      method: 'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      setState({
        ...state,
        isLoading: false
      })
      sectionActividad.arrPrioritarios = response.prioritarios
      sectionActividad.arrOtros = response.otros
      setSectionActividad({ ...sectionActividad, })
    })
  }

  function setRegistraPoliza(opt, index) {
    if(opt === 1) {
      //Primero pedimos toda la información respecto a la póliza...
      const data = { ...arrPrioritarios[index] }

      fetch(`REST/controllers/mainController?opt=preInfoPolizaSC`,{
        method: 'post',
        mode:'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json() )
      .then( response => {
        const newRegistro = {...registro};
        console.log(typeof response.emision)
        newRegistro.id_cotizacion = (response.id_cotizacion == null) ? "" : response.id_cotizacion;
        newRegistro.identificador_cotizador = (response.identificador_cotizador == null) ? "" : response.identificador_cotizador;
        newRegistro.numero_poliza = (response.no_poliza == null) ? "" : response.no_poliza;
        newRegistro.id_ramo = (response.emision !== null) ? (response.emision.id_ramo == null) ? "" : response.emision.id_ramo : "";
        newRegistro.id_usuario = (response.emision !== null) ? (response.emision.id_usuario == null) ? "" : response.emision.id_usuario : "";
        newRegistro.fecha_inicio = (response.emision !== null) ? (response.emision.finicio == null) ? "" : response.emision.finicio : "";
        newRegistro.fecha_fin = (response.emision !== null) ? (response.emision.ffin == null) ? "" : response.emision.ffin : "";
        newRegistro.prima_total = (response.emision !== null) ? (response.emision.primatotal == null) ? "" : response.emision.primatotal : "";
        newRegistro.prima_neta = (response.emision !== null) ? (response.emision.primaneta == null) ? "" : response.emision.primaneta : "";
        newRegistro.forma_pago = (response.emision !== null) ? (response.emision.fpago == null) ? "0" : response.emision.fpago : "0";
        newRegistro.concepto = (response.emision !== null) ? (response.emision.concepto == null) ? "0" : response.emision.concepto : "0";
        newRegistro.company = (response.emision !== null) ? (response.emision.company == null) ? "0" : response.emision.company : "0";
        newRegistro.observacion = (response.emision !== null) ? (response.emision.observacion == null) ? "" : response.emision.observacion : "";

        newRegistro.clave_agente = (response.clave_agente == null) ? "" : response.clave_agente;
        newRegistro.no_negocio = (response.no_negocio == null) ? "" : response.no_negocio;

        setRegistro(newRegistro);
        setLoadRegistro(false);

      })
    }
    /*else {
      const data = {  }
      fetch(`REST/controllers/mainController?opt=setRegistraPoliza`,{
        method: 'post',
        mode:'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json() )
      .then( response => {

      })
    }
    */
  }

  const prepareNewContrato = () => {
    const data = {
      id_ramo : 'io_contrato_autos'
    }
    fetch(`REST/controllers/directoryController?opt=prepareNewContrato`,{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      setState({
        ...state,
        dataContrato : response
      })
    })
  }

  const makeRecibosPagos = () => {
    const { forma_pago, fecha_inicio, prima_total } = registro;
    let iteraciones = [0, 0]
    if(forma_pago === 'm')
      iteraciones = [12, 1]
    if(forma_pago === 's')
      iteraciones = [2, 6]
    if(forma_pago === 't')
      iteraciones = [4, 3]
    if(forma_pago === 'a')
      iteraciones = [1, 12]

    let fecha_recibo = moment(fecha_inicio).format('YYYY-MM-DD'),
    arrRecibosPagos = [],
    costo_unitario = parseFloat(prima_total) / iteraciones[0]
    for(var a = 0; a < iteraciones[0]; a++) {
      if(a > 0)
        fecha_recibo = moment(fecha_recibo).add(iteraciones[1], 'M').format('YYYY-MM-DD');

        arrRecibosPagos.push({
          id: (a + 1),
          fecha: fecha_recibo,
          pgracia: a === 0 ? fecha_recibo : '',
          // [EM] Costo que devuelva solo devolver 2 decimales
          valor: costo_unitario,
        })
    }

    setRegistro({
      ...registro,
      recibos: arrRecibosPagos,
    })
  }

  const setRegisterNuevaPolizaEnd = () => {
    const { 
      id_usuario, 
      id_ramo,
    } = registro;
    let arrAgentes = []
    state.dataContrato.agentes.map((t,e) => {
      if(t.selected)
        arrAgentes.push({ id_agente: t.id_clave })
      return true
    })
    let arrExtra = []
    state.dataContrato.extra.map((t,e) => {
      if(t.value)
        arrExtra.push({
          id_ramo,
          valor: t.value,
          id_hijo: t.id_hijo,
        })
      return true
    })
    const data = {
      obj: {
        id_usuario,
        id_ramo,
        numero: registro.numero_poliza,
        finicio: registro.fecha_inicio,
        ffin: registro.fecha_fin,
        primatotal: registro.prima_total,
        primaneta: registro.prima_neta,
        fpago: registro.forma_pago,
        concepto: registro.concepto,
        company: registro.company,
        agentes: arrAgentes,
        recibos: registro.recibos,
        extra: arrExtra,
        observacion: registro.observacion,
        notify: 0, //[EM], no borres esto, por defecto no notificaremos
        // email_nombre: "Jesus Yanez Mar",
        // email_concepto:"Mensual",
        // email_compania:"QUÁLITAS",
        // email_prima:"$1,000.00",
        id_agente: arrAgentes.length === 0 ? '' : arrAgentes[0].id_agente,
        renovation: 0,
        id_contrato_hold: '',
        moneda: "mxn",
      }
    }

    const url = "https://wsdl.segurocotizas.com/";
    let identificador_url = (registro.identificador_cotizador==='qualitas') ? 'segurosQualitas' : `index_${registro.identificador_cotizador}`;
    const dataImprimir = {
      'id_cotizacion' : registro.id_cotizacion,
      'opt' : 'I'
    }
    fetch(`${url}${identificador_url}.php`,{
      method: 'POST',
      mode:'cors',
      body : JSON.stringify(dataImprimir)
    })
    .then( response => response.json() )
    .then( response => {

      if(typeof response.error !== 'undefined'){
        alert(response.error);
        return false;
      }

      if(response.impresion!=""){
        data.files = response.impresion;
        
        fetch('REST/controllers/directoryController?opt=setContratoNuevo',{
          method: 'post',
          mode:'cors',
          body: JSON.stringify(data)
        })
        .then( response => response.json() )
        .then( response => {
          if(response.service) {
            setShowSidebarRight(false);
            alert('¡La póliza se generó con éxito!')
          }
        })

      }else{
        alert('No se encontró la póliza')
      }

    })

  }

  const submitFormRegistroStep1 = (e) => {
    e.preventDefault();
    setState({
      ...state,
      stepNuevaPoliza : 2
    })
    makeRecibosPagos();
  }

  const { arrPrioritarios, } = sectionActividad

  // const searchData;
  // let filteredData = [];

  // if(opt === 0) searchData = '';
  // if(opt === 1) searchData = arrPagados;
  // if(opt === 2) searchData = arrVencidos;
  // if(section === 4) searchData = arrRenovaciones;

  // if (search_input == "") {
  //   filteredData = searchData;
  // } else {
  //   filteredData = searchData.filter((el) => {
  //     const { nombre_usuario, numero_poliza } = el;
  //     return (
  //       nombre_usuario.toLowerCase().includes(searchData) ||
  //       numero_poliza.toLowerCase().includes(searchData)
  //     );
  //   });
  // }

  return(
    <div className="container-fluid">
      <div className="ws-main-container">

        {/* <div className="ws-tab-container pb-3">
          <div className="row mt-3">
            <Col xs={3}>
              <Form onSubmit={ (e) => e.preventDefault() }>
                <Form.Group>
                  <Form.Select value={state.opt} onChange={ (e) => setState({ ...state, opt: e.target.value }) }>
                    <option value="0">Todas</option>
                    <option value="1">Cotizaciones</option>
                    <option value="2">Emisiones pendientes</option>
                  </Form.Select>
                </Form.Group>
              </Form>
            </Col> 
          </div>
        </div> */}

        <div className="row">
          <div className="col-12">
            <div className="ws-box-container">
              { (state.isLoading) && (<div className="ws-loader-container"><div className="spinner"></div></div>) }
              <h4>Actividades pendientes</h4>
              <Table responsive hover>
                <thead>
                    <tr>
                      <th width="26%">Actividad</th>
                      <th width="15%">Fecha</th>
                      <th width="25%">Opciones</th>
                    </tr>
                </thead>
                <tbody>
                  {
                    (sectionActividad.arrPrioritarios.length < 1) && (
                      <tr>
                        <td colSpan={3}>  
                          <p className="mb-2 mt-2 text-center">No hay actividades pendientes</p>
                        </td>
                      </tr>
                    )
                  }

                  {
                    (sectionActividad.arrPrioritarios.length > 0) && (
                      sectionActividad.arrPrioritarios.map((item,index) => {
                        const { type } = item
                        let nombre = ''
                        if(type === 'cotizar')
                          nombre = 'Alguien realizó una cotización.'
                        else if(type === 'emitir')
                          nombre = 'Tienes una emisión pendiente.'
                        else if(type === 'elegir_paquete')
                          nombre = 'Alguien eligió un paquete.'
                        
                        return(
                          <tr key={index}>  
                            <td>{nombre}</td>
                            <td> {moment(item.created_at).format('DD/MM/YYYY HH:mm')} </td>
                            <td>
                              {
                              type === "cotizar" || type === "elegir_paquete"
                                ? (
                                  <>
                                  <Button className="ws-btn-blue-2 me-2" onClick={() => {
                                        window.open(`https://demo.segurocotizas.com/visualizar?id_cotizacion=${item.subItem.id_cotizacion}`, '_blank')
                                      }} variant='primary'>Ver cotización</Button>
                                  <Button className="me-2" onClick={() => { setOcultaPrioritario(index) }} variant='secondary'>Ocultar</Button>
                                  </>
                                ) : null
                              }
                              {
                                type === "emitir"
                                ? (
                                  <>
                                  <Button 
                                  className="me-2" 
                                  onClick={() => {
                                    setLoadRegistro(true);
                                    setShowSidebarRight(true);
                                    prepareNewContrato();
                                    setRegistraPoliza(1, index)
                                    console.log('index',index);
                                  }} 
                                  variant='success'>
                                    Agregar póliza a sistema
                                  </Button>
                                  <Button className="ws-btn-blue-2 me-2" onClick={() => {
                                    window.open(`https://demo.segurocotizas.com/visualizar?id_cotizacion=${item.subItem.id_cotizacion}`, '_blank')
                                  }} variant='primary'>Ver emisión</Button>
                                  <Button onClick={() => { setOcultaPrioritario(index) }} variant='secondary'>Ocultar</Button>
                                  </>
                                ) : null
                              }
                            </td>
                          </tr>
                        )
                      })
                    )
                  }
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      {/* <RightSidebarInter status={showSidebarRight} setState={setShowSidebarRight} title="COTIZACIÓN DE STICKER DE ADUANA"
      onClose={ () => console.log('close sidebar') }
      >
        <React.Fragment>
          <Form>
            <Row className="ws-form-group-divider pb-3 pt-3"> 
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    FECHA DE LA COTIZACIÓN
                  </Form.Label>
                  <Form.Control type="date" />
                </Form.Group>
              </Col>
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    VIGENTE HASTA
                  </Form.Label>
                  <Form.Control type="date" />
                </Form.Group>
              </Col>
            </Row>

            <Row className="ws-form-group-divider pb-3 pt-3"> 
              <Col xs={12}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    NOMBRE DEL CLIENTE
                  </Form.Label>
                  <Form.Control type="text" placeholder="" />
                </Form.Group>
              </Col>
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    DBA
                  </Form.Label>
                  <Form.Control type="text" placeholder="" />
                </Form.Group>
              </Col>
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    NÚMERO DOT
                  </Form.Label>
                  <Form.Control type="text" placeholder="" />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    DOMICILIO
                  </Form.Label>
                  <Form.Control type="text" placeholder="" />
                </Form.Group>
              </Col>
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    TELÉFONO
                  </Form.Label>
                  <Form.Control type="text" placeholder="" />
                </Form.Group>
              </Col>
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    CORREO ELECTRÓNICO
                  </Form.Label>
                  <Form.Control type="text" placeholder="" />
                </Form.Group>
              </Col>
            </Row>

            <Row className="ws-form-group-divider pb-3 pt-3">
              <h5 className="ws-form-group-title">PRODUCTO</h5>
              <Col xs={12}>
                <Form.Group className="mb-2">
                  <Form.Check type="radio" name="group1" inline label="NUEVO DECAL" id="check1" /> 
                  <Form.Check type="radio" name="group1" inline label="NUEVO DECAL" id="check2" /> 
                  <Form.Check type="radio" name="group1" inline label="NUEVO DECAL" id="check3" /> 
                </Form.Group>  
              </Col>
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    CANTIDAD DE UNIDADES
                  </Form.Label>
                  <Form.Select> 
                    <option value="">Selecciona una opción</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} lg={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="ws-form-label">  
                    AÑO DEL DECAL SOLICITADO
                  </Form.Label>
                  <Form.Select> 
                    <option value="">Selecciona una opción</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            
          </Form>
        </React.Fragment>
      </RightSidebarInter> */}

      <RightSidebar status={showSidebarRight} setStatus={setShowSidebarRight} 
      title="Registrar nuevo contrato"
      onClose={
        () => {
          setState({
            ...state,
            stepNuevaPoliza: 1
          })
        }
      }
      >
        {
          // Paso 1, registrar datos del vehículo
          (state.stepNuevaPoliza===1) && (
            <React.Fragment>
              { (loadRegistro) && (<div className="ws-loader-container"><div className="spinner"></div></div>) }
              <h5 style={{fontSize:'2rem',fontWeight:'800'}}>PASO 1</h5>
              <hr />

              <Form onSubmit={submitFormRegistroStep1}>  
                <Row> 
                  <Col xs={12}> 
                    <div className='mb-3'>
                      <p className='ws-newramo-title'>Número de póliza</p>
                      <input className='ws-newramo-input' type={'text'} placeholder={'Ingresa el número de póliza...'}
                      name="numero_poliza"
                      value={registro.numero_poliza}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      />
                    </div>
                  </Col>
                  <Col xs={12} lg={6}>
                    <div className='mb-3'>
                      <p className='ws-newramo-title'>Fecha inicio de vigencia</p>
                      <input className='ws-newramo-input' type={'date'}
                      name="fecha_inicio"
                      value={registro.fecha_inicio}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      />
                    </div>
                  </Col> 
                  <Col xs={12} lg={6}>
                    <div className='mb-3'> 
                      <p className='ws-newramo-title'>Fecha fin de vigencia</p>
                      <input className='ws-newramo-input' type={'date'}
                      name="fecha_fin"
                      value={registro.fecha_fin}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      />
                    </div>
                  </Col> 
                  <Col xs={12} lg={6}>
                    <div className='mb-3'> 
                      <p className='ws-newramo-title'>Prima total</p>
                      <input className='ws-newramo-input' type={'text'}
                      name="prima_total"
                      value={registro.prima_total}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      />
                    </div>
                  </Col> 
                  <Col xs={12} lg={6}>
                    <div className='mb-3'> 
                      <p className='ws-newramo-title'>Prima neta</p>
                      <input className='ws-newramo-input' type={'text'}
                      name="prima_neta"
                      value={registro.prima_neta}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      />
                    </div>
                  </Col>
                  <Col xs={12} lg={6}>
                    <div className='mb-3'> 
                      <p className='ws-newramo-title'>Forma de pago</p>
                      <select 
                      style={{height:'45px'}} 
                      className='ws-newramo-input' 
                      name="forma_pago"
                      value={registro.forma_pago}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      >
                        <option value={'0'} disabled={true}>Selecciona una opción</option>
                        <option value={'m'}>Mensual</option>
                        <option value={'t'}>Trimestral</option>
                        <option value={'s'}>Semestral</option>
                        <option value={'a'}>Anual</option>
                      </select>
                    </div>
                  </Col> 
                  <Col xs={12} lg={6}>
                    <div className='mb-3'> 
                      <p className='ws-newramo-title'>Concepto</p>
                      <select
                      style={{height:'45px'}}
                      className='ws-newramo-input'
                      name="concepto"
                      value={registro.concepto}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      >
                        <option value={0} disabled={true}>Selecciona un concepto</option>
                        <option value={'e'}>Efectivo</option>
                        <option value={'c'}>Cargo a tarjeta</option>
                      </select>
                    </div>
                  </Col> 
                  <Col xs={12} lg={6}>
                    <div className='mb-3'> 
                      <p className='ws-newramo-title'>Compañía</p>
                      <select
                      className='ws-newramo-input'
                      name="company"
                      style={{height:'45px'}}
                      value={registro.company}
                      onChange={(ev) => {
                        const { name, value } = ev.target;
                        setRegistro({
                          ...registro,
                          [name] : value
                        })
                      }}
                      required
                      >
                        <option value={0} disabled={true}>Selecciona una compañía</option>
                        {
                          state.dataContrato.companias.map((item, index) => (
                            <option key={`key-companias-${index}`} value={item.id_compania}>{item.nombre}</option>
                          ))
                        }
                      </select>
                    </div>
                  </Col>
                  <Col xs={12}>
                    <p className='ws-newramo-title mb-4'>Agentes</p>
                    {
                      state.dataContrato.agentes.map((item, index) => (
                        <Row key={`key-listagentes-${index}`} style={{borderBottom:'1px solid #f3f3f3'}}>
                        
                          <Col md={2} className="pt-3 pb-3" onClick={() => {
                            item.selected = !item.selected
                          }}>
                            
                            <p style={{cursor:'pointer'}}>{item.selected 
                              ? <i className="material-icons pointer" id="ws_principal_filter" style={{fontSize:'1.8rem',marginRight:6,color:'#ff355c'}}>check_box</i> 
                              : <i className="material-icons pointer" id="ws_principal_filter" style={{fontSize:'1.8rem',marginRight:6,color:'#777'}}>check_box_outline_blank</i> }</p>
                          </Col>

                          <Col md={10} className="pt-3 pb-3">
                            <p style={{fontSize:'1.2rem',color:'#333',margin:'0px',fontWeight:'600',textTransform:'uppercase'}}>{item.nombre}</p>
                            <p>{item.clave}</p>
                          </Col>
                        </Row>
                      ))
                    }
                  </Col> 
                  <Col xs={12}>
                    <Button type="submit" className={`ws-newramo-continue d-flex justify-content-center ${classes.BtnPrimary}`} variant="primary">
                      Continuar
                      <i className="material-icons">arrow_forward</i>
                    </Button> 
                  </Col>
                </Row>
              </Form>

            </React.Fragment>
          )
        }
        {
          // Paso 2, pasar al simulador
          (state.stepNuevaPoliza===2) && (
            <React.Fragment>
              <h5 style={{fontSize:'2rem',fontWeight:'800'}}>PASO 2</h5>
              <hr />
              <p style={{cursor:'pointer'}} onClick={() => {
                setState({
                  ...state,
                  stepNuevaPoliza: 1
                })
              }}>Regresar</p>

              {
                registro.recibos.map((item,index) => (
                  <Row key={`key-fichanewpoliza-${index}`}> 
                    {
                      index === 0 ? (
                        <React.Fragment>
                          <Col xs={1}><p className="ws-newramo-countrecipt mb-0">#{item.id}</p></Col>
                          <Col xs={4}>
                            <input className='ws-newramo-input' type={'date'}
                            value={item.fecha}
                            onChange={(ev) => {
                              item.fecha = ev.target.value;
                              setRegistro({...registro})
                            }}
                            />
                          </Col>
                          <Col xs={4}>
                            <input className='ws-newramo-input' type={'date'}
                              value={item.pgracia}
                              onChange={(ev) => {
                                item.pgracia = ev.target.value
                                setRegistro({...registro})
                              }}
                            />
                            <p>Periodo de gracia</p>
                          </Col>
                          <Col xs={3}>
                            <input className='ws-newramo-input' type={'text'}
                              onChange={(ev) => {
                                // Alteramos solo el primer valor
                                item.valor = ev.target.value
                                // Ahora recalculamos el resto en primas
                                const fracciones = ((parseFloat(registro.prima_total) - parseFloat(item.valor)) / (registro.recibos.length - 1))
                                registro.recibos.map((t,e) => {
                                  if(e > 0)
                                    t.valor = fracciones
                                  return true;
                                })
                                setRegistro({...registro})
                              }}
                              value={item.valor}
                            />
                          </Col>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Col xs={1}><p className="ws-newramo-countrecipt mb-0">#{item.id}</p></Col>
                          <Col xs={5}>
                            <input className='ws-newramo-input' type={'date'}
                              value={item.fecha}
                            />
                          </Col>
                          <Col xs={5}>
                            <p className="mb-0" style={{fontSize:'1.6rem'}}>{item.valor}</p>
                          </Col>
                          <hr className="mt-4" />
                        </React.Fragment>
                      )
                    }
                  </Row>
                ))
              }

              <h5>Extra</h5>
              <hr />

              {
                state.dataContrato.extra && state.dataContrato.extra.map((item, index) => (
                  <Row key={`key-extra-${index}`} className="mb-3">
                    <Col md={4}>
                      <p>{item.nombre}</p>
                    </Col>
                    <Col>
                      <input 
                      className='ws-newramo-input'
                      onChange={(ev) => {
                        state.dataContrato.extra[index].value = ev.target.value;
                        setState({...state})
                      }}
                      value={item.value} type={'text'} />
                    </Col>
                  </Row>
                ))
              }

              <h5>Observación</h5>
              <hr />
              <textarea 
              style={{width:'100%',resize:'none',height:'auto'}}
              rows={4}
              onChange={(ev) => {
                registro.observacion = ev.target.value;
                setRegistro({...registro})
              }}
              value={registro.observacion}></textarea>

              <Button className={`ws-newramo-continue d-flex justify-content-center ${classes.BtnPrimary}`} variant="primary" onClick={() => {
                state.stepNuevaPoliza = 3
                setState({ ...state, })
              }}>
                Continuar
                <i className="material-icons">arrow_forward</i>
              </Button>

            </React.Fragment>
          )
        }
        {
          // Paso 3, pasar a confirmar
          (state.stepNuevaPoliza===3) && (
            <React.Fragment>
              <h5 style={{fontSize:'2rem',fontWeight:'800'}}>PASO 3</h5>
              <hr />
              <p style={{
                padding:'5px',
                borderRadius:'4px',
                marginBottom:'20px',
                color:'#777',
                cursor:'pointer'
              }} onClick={() => {
                state.stepNuevaPoliza = 2
                setState({ ...state })
              }}>Regresar</p>

              <h6 className="text-center" style={{textTransform:'uppercase',fontWeight:'800',letterSpacing:'2px',fontSize:'1.3rem'}}>Por registrar</h6>
              <Row className='mb-3'>
                <Col className="ws-text-contrato">Número de contrato</Col>
                <Col>{registro.numero_poliza}</Col>
              </Row>
              <Row className='mb-3'>
                <Col className="ws-text-contrato">Fecha inicio de vigencia</Col>
                <Col>{registro.fecha_inicio}</Col>
              </Row>
              <Row className='mb-3'>
                <Col className="ws-text-contrato">Fecha fin de vigencia</Col>
                <Col>{registro.fecha_fin}</Col>
              </Row>
              <Row className='mb-3'>
                <Col className="ws-text-contrato">Prima total</Col>
                <Col>{registro.prima_total}</Col>
              </Row>
              <Row className='mb-3'>
                <Col className="ws-text-contrato">Recibos</Col>
                <Col>{registro.recibos.length}</Col>
              </Row>
              <Row className='mb-3'>
                <Col className="ws-text-contrato">Concepto</Col>
                <Col>{registro.concepto === 'e' ? 'Efectivo' : 'Cargo a tarjeta'}</Col>
              </Row>

              <Row className="mt-4 mb-5">
                <Col>
                  <Button className={`ws-newramo-continue ${classes.BtnPrimary}`} variant="primary" onClick={() => {
                    
                  }}>Registrar y notificar al cliente</Button>
                </Col>
                <Col>
                  <Button className={`ws-newramo-continue ${classes.BtnPrimary}`} variant="primary" onClick={() => {
                    setRegisterNuevaPolizaEnd()
                  }}>Solo registrar</Button>
                </Col>
              </Row>

            </React.Fragment>
          )
        }
      </RightSidebar>
    </div>
  ) 
}